<template>
  <div>
    <PageTitle
      title="Suppliers"
      :btnCreate="true"
      :createRoute="'/supplier/add'"
      :permission="'Supplier Create'"
    />
    <v-container
      fluid
      class="lighten-12 content"
      style="background-color: white"
    >
      <v-btn :ripple="false" class="min-button" icon @click="show = !show">
        <v-icon color="blue" class="ml-10">
          {{ show ? 'mdi-filter' : 'mdi-filter-outline' }}
        </v-icon>
        <span class="subheading filterclor">Filter</span>
      </v-btn>
      <v-expand-transition>
        <v-card class="lighten-12 card-content mb-2" v-show="show">
          <TableFilters
            :filters="['status', 'search', 'product']"
            v-model="filter"
            :columns="columns"
            paginationOptions
            :msgs="'Name/Reference Number'"
          >
          </TableFilters>
        </v-card>
      </v-expand-transition>

      <v-card class="lighten-12 mt-2">
        <v-container fluid class="light gray lighten-12">
          <v-row>
            <v-card-text class="pa-0">
              <v-data-table
                :items-per-page="paginationOptions.perPage"
                :headers="headers"
                :items="suppliers"
                :single-expand="singleExpand"
                :expanded.sync="expanded"
                item-key="name"
                show-expand
                hide-default-footer
                @click:row="$router.push(`supplier/${$event.id}`)"
                class="row-pointer"
                style="font-family: 'Source Sans Pro', sans-serif"
              >
                <template v-slot:no-data>
                  <noData
                    class="mt-16 container justify-center item-center"
                    name="supplier"
                  />
                </template>
                <template v-slot:item.due_amount="{ item }">
                  <v-chip
                    v-if="item.due_amount > 0"
                    :x-small="true"
                    label
                    text-color="white"
                    style="
                      font-weight: bold;
                      font-size: revert;
                      text-align: center;
                    "
                    color="red"
                    dark
                    >{{
                      item.due_amount
                        ? item.due_amount
                        : '---------' | formatCurrency
                    }}</v-chip
                  >
                  <v-chip
                    v-else
                    :x-small="true"
                    style="font-weight: bold; font-size: revert"
                    class="ma-2"
                    label
                    text-color="white"
                    color="green"
                    dark
                    >{{
                      item.due_amount
                        ? item.due_amount
                        : '---------' | formatCurrency
                    }}</v-chip
                  >
                </template>
                <template v-slot:item.reference_number="{ item }">
                  <div>
                    <CopyTableCell
                      :text="item.reference_number"
                    ></CopyTableCell>
                  </div>
                </template>

                <template v-slot:item.name="{ item }">
                  <div>
                    <CopyTableCell :text="item.name"></CopyTableCell>
                  </div>
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length" class="px-5">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        lg="6"
                        v-if="item.contacts.length"
                      >
                        <v-card class="lighten-12">
                          <v-card-title class="v-card__title saletiltle"
                            ><v-icon small color="blue">mdi-contacts</v-icon
                            ><span class="pl-3"> Contact</span>
                          </v-card-title>
                          <v-container fluid class="container saledetailscard">
                            <v-row>
                              <v-col
                                cols="12"
                                sm="12"
                                md="12"
                                lg="12"
                                class="pt-0 sub-section"
                                v-for="item in item.contacts"
                                :key="item"
                              >
                                <v-row class="pt-0">
                                  <v-col
                                    cols="5"
                                    sm="12"
                                    md="5"
                                    lg="5"
                                    class="paymenttext"
                                  >
                                    Full Name
                                  </v-col>
                                  <v-col
                                    cols="7"
                                    sm="12"
                                    md="7"
                                    lg="7"
                                    class="saletiltle"
                                    style="text-align: right"
                                  >
                                    {{
                                      item.full_name ? item.full_name : '---'
                                    }}
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="pt-0">
                                  <v-col
                                    cols="5"
                                    sm="12"
                                    md="5"
                                    lg="5"
                                    class="paymenttext"
                                  >
                                    Telephone
                                  </v-col>
                                  <v-col
                                    cols="7"
                                    sm="12"
                                    md="7"
                                    lg="7"
                                    class="saletiltle"
                                    style="text-align: right"
                                  >
                                    <a
                                      href=""
                                      :style="
                                        item.telephone && item.telephone
                                          ? { color: 'light-blue' }
                                          : { 'text-decoration': 'none' }
                                      "
                                    >
                                      {{
                                        item.telephone ? item.telephone : '---'
                                      }}</a
                                    >
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="pt-0">
                                  <v-col
                                    cols="5"
                                    sm="12"
                                    md="5"
                                    lg="5"
                                    class="paymenttext"
                                  >
                                    Phone
                                  </v-col>
                                  <v-col
                                    cols="7"
                                    sm="12"
                                    md="7"
                                    lg="7"
                                    class="saletiltle"
                                    style="text-align: right"
                                  >
                                    <a href="">
                                      {{ item.phone ? item.phone : '---' }}</a
                                    >
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="pt-0">
                                  <v-col
                                    cols="5"
                                    sm="12"
                                    md="5"
                                    lg="5"
                                    class="paymenttext"
                                  >
                                    Email
                                  </v-col>
                                  <v-col
                                    cols="7"
                                    sm="12"
                                    md="7"
                                    lg="7"
                                    class="saletiltle"
                                    style="text-align: right"
                                  >
                                    {{ item.email ? item.email : '---' }}
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="pt-0">
                                  <v-col
                                    cols="5"
                                    sm="12"
                                    md="5"
                                    lg="5"
                                    class="paymenttext"
                                  >
                                    Contactable Type
                                  </v-col>
                                  <v-col
                                    cols="7"
                                    sm="12"
                                    md="7"
                                    lg="7"
                                    class="saletiltle"
                                    style="text-align: right"
                                  >
                                    {{
                                      item.contactable_type
                                        ? item.contactable_type
                                        : '---'
                                    }}
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        lg="6"
                        v-if="item.addresses.length"
                      >
                        <v-card class="lighten-12">
                          <v-card-title class="v-card__title saletiltle"
                            ><v-icon color="blue" small>mdi-city</v-icon
                            ><span class="pl-3"> Address</span>
                          </v-card-title>
                          <v-container fluid class="container saledetailscard">
                            <v-row>
                              <v-col
                                cols="12"
                                sm="12"
                                md="12"
                                lg="12"
                                class="pt-0 sub-section"
                                v-for="item in item.addresses"
                                :key="item"
                              >
                                <v-row class="pt-0">
                                  <v-col
                                    cols="5"
                                    sm="12"
                                    md="5"
                                    lg="5"
                                    class="paymenttext"
                                  >
                                    Address Line 1
                                  </v-col>
                                  <v-col
                                    cols="7"
                                    sm="12"
                                    md="7"
                                    lg="7"
                                    class="saletiltle"
                                    style="text-align: right"
                                  >
                                    {{
                                      item.address_line1
                                        ? item.address_line1
                                        : '---'
                                    }}
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="pt-0">
                                  <v-col
                                    cols="5"
                                    sm="12"
                                    md="5"
                                    lg="5"
                                    class="paymenttext"
                                  >
                                    Address Line 2
                                  </v-col>
                                  <v-col
                                    cols="7"
                                    sm="12"
                                    md="7"
                                    lg="7"
                                    class="saletiltle"
                                    style="text-align: right"
                                  >
                                    {{
                                      item.address_line2
                                        ? item.address_line2
                                        : '---'
                                    }}
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="pt-0">
                                  <v-col
                                    cols="5"
                                    sm="12"
                                    md="5"
                                    lg="5"
                                    class="paymenttext"
                                  >
                                    City
                                  </v-col>
                                  <v-col
                                    cols="7"
                                    sm="12"
                                    md="7"
                                    lg="7"
                                    class="saletiltle"
                                    style="text-align: right"
                                  >
                                    {{ item.city ? item.city : '---' }}
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="pt-0">
                                  <v-col
                                    cols="5"
                                    sm="12"
                                    md="5"
                                    lg="5"
                                    class="paymenttext"
                                  >
                                    Postal Code
                                  </v-col>
                                  <v-col
                                    cols="7"
                                    sm="12"
                                    md="7"
                                    lg="7"
                                    class="saletiltle"
                                    style="text-align: right"
                                  >
                                    {{
                                      item.postal_code
                                        ? item.postal_code
                                        : '---'
                                    }}
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="pt-0">
                                  <v-col
                                    cols="5"
                                    sm="12"
                                    md="5"
                                    lg="5"
                                    class="paymenttext"
                                  >
                                    Country
                                  </v-col>
                                  <v-col
                                    cols="7"
                                    sm="12"
                                    md="7"
                                    lg="7"
                                    class="saletiltle"
                                    style="text-align: right"
                                  >
                                    {{
                                      item.country ? item.country.name : '---'
                                    }}
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card>
                      </v-col>
                    </v-row>
                  </td>
                </template>
                <!-- Status -->
                <template v-slot:item.is_active="{ item }">
                  <v-chip
                    :x-small="true"
                    class="ma-2"
                    label
                    style="font-weight: 800; font-variant-caps: all-small-caps"
                    text-color="white"
                    :color="getStatusColor(item.is_active)"
                    dark
                    >{{ item.is_active ? 'Active' : 'Archived' }}</v-chip
                  >
                </template>

                <!-- Action -->
                <template v-slot:item.action="{ item }">
                  <list-menu
                    feature="supplier"
                    :item="item"
                    viewPermission="Supplier Show"
                    editPermission="Supplier Edit"
                    softDeletePermission="Supplier Soft Delete"
                    @refreshList="refreshData"
                  ></list-menu>
                </template>
                <template v-slot:footer>
                  <pagination
                    @paginationOptions="setPaginationOptions"
                    @response="setResponseData"
                    :filterAction="true"
                    @getPageNumber="setPagenumber"
                    url="supplier"
                    :filter="filter"
                    ref="pagination"
                  />
                </template>
              </v-data-table>
            </v-card-text>
          </v-row>
        </v-container>
      </v-card>
      <!-- </v-card> -->
      <div class="d-flex justify-center align-center"></div>
    </v-container>
  </div>
</template>
<script>
import pagination from '../../shared/components/pagination.vue';
import confirmation from '../../shared/components/confirmation';
import { SupplierListViewModel } from '../../../models/View Models/Supplier';
import { Product } from '../../../models/Product';
import ProductAutoCompleteComponent from '@/components/base/ProductAutoCompleteComponent';
import TableFilters from '@/components/base/TableFilters';
import noData from '../../../components/shared/noItem';

export default {
  components: {
    TableFilters,
    ProductAutoCompleteComponent,
    pagination,
    noData,
  },
  data() {
    return {
      paginationOptions: {},
      expanded: [],
      singleExpand: false,
      isLoading: true,
      show: false,
      columns: [
        {
          text: 'Name',
          value: 'name',
          show: true,
          align: 'left',
          disabled: false,
          sortable: false,
          width: '20%',
        },
        {
          text: 'Reference Number',
          value: 'reference_number',
          show: true,
          align: 'left',
          disabled: false,
          width: '20%',
          sortable: false,
        },
        {
          text: 'Due Amount',
          value: 'due_amount',
          show: true,
          align: 'center',
          disabled: false,
          width: '25%',
          sortable: false,
        },
        {
          text: 'Status',
          value: 'is_active',
          show: true,
          disabled: false,
          align: 'center',
          width: '20%',
          sortable: false,
        },
        {
          text: 'Actions',
          value: 'action',
          show: true,
          disabled: false,
          align: 'center',
          width: '20%',
          sortable: false,
        },
      ],
      contactHeaders: [
        { text: 'Name', value: 'full_name', align: 'left' },
        { text: 'Phone', value: 'phone', align: 'left' },
        { text: 'Telephone', value: 'telephone', align: 'left' },
        {
          text: 'Email',
          value: 'email',
          align: 'left',
          show: true,
          disabled: false,
        },
      ],
      addressHeaders: [
        {
          text: 'Address Line1',
          align: 'left',
          value: 'address_line1',
          show: true,
          disabled: false,
        },
        {
          text: 'Address Line2',
          value: 'address_line2',
          show: true,
          align: 'left',
          disabled: false,
        },
        {
          text: 'City',
          value: 'city',
          align: 'left',
          show: true,
          disabled: false,
        },
        {
          text: 'Country',
          value: 'country.name',
          align: 'left',
          show: true,
          disabled: false,
        },
        {
          text: 'Postal Code',
          value: 'postal_code',
          show: true,
          align: 'left',
          disabled: false,
        },
      ],
      suppliers: [],
      newSupplier: { name: '', id: '', is_active: '' },
      filter: {
        name: '',
        search: '',
        status: '',
      },
      searchProduct: null,
      products: [],
    };
  },
  methods: {
    setPagenumber(event) {
      this.$router.push('?page=' + event);
      this.$store.dispatch('SetProductSize', event);
    },
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    clearFilter() {
      this.filter = {};
    },
    refreshData() {
      this.$refs.pagination.refreshData();
    },
    AddSupplier() {
      this.$router.push({ path: '/supplier/add' });
    },

    setResponseData(supplier) {
      this.suppliers = supplier.map((u, i, arr) => {
        u.index = i + 1;
        return new SupplierListViewModel(u);
      });
    },
    getStatusColor(status) {
      return status ? 'green' : 'gray';
    },
  },
  computed: {
    // Filter - return selected table fields
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
  created() {},
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap');

.f-100 {
  text-align: center;
}

.saletiltle {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 2px;
}
.saledetailscard {
  background: #fffefe;
  box-sizing: border-box;
  border: 1px solid #afa9a9;
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.paymenttext {
  font-family: Roboto;
  font-style: normal;
  /* font-weight: bold; */
  font-size: 12px;
  line-height: 12px;
  /* identical to box height */

  text-align: left;

  color: #928686;
}
.filterclor {
  color: cornflowerblue;
  font-size: larger;
  font-weight: bold;
}
.min-button::before {
  display: none;
}
</style>
